import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { includeBearerTokenInterceptor } from 'keycloak-angular';
import { environment } from 'src/environments/environment';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { SharedModule } from './shared/shared.module';
import { BASE_PATH } from '@iota/iota-management-portal-v4-client';
import { BASE_PATH as BASE_PATH_CDN } from '@iota/iota-cdn-v4-client';
import { BASE_PATH as BASE_PATH_CORE } from '@iota/inh-core-v1-management-client';

import { IotaUiComponentsModule, MAT_DATE_LOCALE, MAT_PAGINATOR_DEFAULT_OPTIONS, MatPaginatorIntl } from '@iota/iota-ui-components';

import { effects, metaReducers, reducers } from './store/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { VersionInformationComponent } from './version-information/version-information.component';
import { PaginatorIntlService } from './shared/services/paginator-intl.service';
import { AcceptLanguageInterceptorService } from './shared/services/accept-language-interceptor.service';
import { DEFAULT_PAGE_SIZE_OPTIONS } from './shared/constants-and-enums/pagination';
import { provideKeycloakAuth } from './shared/keycloak.providers';
import { provideChunkReload } from './shared/chunk-reload.providers';

@NgModule({
    declarations: [AppComponent, VersionInformationComponent],
    imports: [
        BrowserModule,
        IotaUiComponentsModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        SharedModule,
        LayoutModule,
        StoreModule.forRoot(reducers, { metaReducers: metaReducers }),
        EffectsModule.forRoot(effects),
        // Connects RouterModule with StoreModule, uses MinimalRouterStateSerializer by default
        StoreRouterConnectingModule.forRoot(),
        !environment.production
            ? StoreDevtoolsModule.instrument({
                  maxAge: 50,
                  connectInZone: true
              })
            : []
    ],
    providers: [
        provideHttpClient(withInterceptors([includeBearerTokenInterceptor]), withInterceptorsFromDi()),
        provideKeycloakAuth(),
        provideChunkReload(),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AcceptLanguageInterceptorService,
            multi: true
        },
        {
            provide: BASE_PATH,
            useValue: environment.basePath
        },
        {
            provide: BASE_PATH_CDN,
            useValue: environment.basePathCdn
        },
        {
            provide: BASE_PATH_CORE,
            useValue: environment.basePathCore
        },
        {
            provide: MAT_DATE_LOCALE,
            useValue: 'de-DE'
        },
        { provide: MatPaginatorIntl, useClass: PaginatorIntlService },
        { provide: MAT_PAGINATOR_DEFAULT_OPTIONS, useValue: { pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS } }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
